import {
  SET_SCHOOL_SEARCH
} from '@/store/mutation-types'

export default {
  [SET_SCHOOL_SEARCH] (state, payload) {
    state.searchSchool = payload
  }
}



// WEBPACK FOOTER //
// ./src/components/schools/store/mutations.js